import React                from 'react';
import { Observe }               from 'rewire-core';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import summaryListModel          from './SummaryListModel';

const TimecardFooter = React.memo(() => {
  return <Observe render={() => (
    <MainContentFooterPaging model={summaryListModel.pagingModel} />
  )} />;
});

export default TimecardFooter;